export default __webpack_public_path__ + "static/gallery20-425a80a7321c8415048a7dca9c1b385e.png";